import type { LenderApplicationsFilterEnum } from "./common/enums";
import type { ILenderResponseInput } from "./lender-responses/types/lender-response";

export const queryKeyMap = {
  getAccountingData: (loanApplicationId: number) => [
    "GET_ACCOUNTING_DATA",
    loanApplicationId,
  ],
  // users
  getMe: ["GET_ME"],
  getLenderCompanyUsers: (lenderCompanyId: number) => [
    "GET_LENDER_COMPANY_USERS",
    lenderCompanyId,
  ],
  // lender companies
  getMyLenderCompanies: (search?: string) => [
    "GET_MY_LENDER_COMPANIES",
    search,
  ],

  // lender applications
  getLenderApplications: (
    filter: LenderApplicationsFilterEnum,
    sort?: string,
  ) =>
    sort
      ? ["GET_LENDER_APPLICATIONS", filter, sort]
      : ["GET_LENDER_APPLICATIONS", filter],
  getLenderApplicationsCounts: ["GET_LENDER_APPLICATIONS_COUNTS"],
  getLenderApplication: (lenderApplicationId: number) => [
    "GET_LENDER_APPLICATION",
    lenderApplicationId,
  ],
  searchLenderApplications: (search: string) => [
    "SEARCH_LENDER_APPLICATIONS",
    search,
  ],
  getLenderCompany: (lenderCompanyId: number) => [
    "GET_LENDER_COMPANY",
    lenderCompanyId,
  ],
  getOfferAttractiveness: (
    lenderCompanyId: number,
    lenderApplicationId: number,
    input: ILenderResponseInput,
  ) => [
    "GET_OFFER_ATTRACTIVENESS",
    lenderCompanyId,
    lenderApplicationId,
    input,
  ],
  getListAuditLogs: (lenderCompanyId: number) => [
    "GET_LIST_AUDIT_LOGS",
    lenderCompanyId,
  ],
  getLenderResponsePreview: (
    lenderCompanyId: number,
    lenderApplicationId: number,
    input: ILenderResponseInput,
  ) => [
    "GET_LENDER_RESPONSE_PREVIEW",
    lenderCompanyId,
    lenderApplicationId,
    input,
  ],
} as const;

export const mutationKeyMap = {
  updateUser: ["UPDATE_USER"],
  inviteUser: ["INVITE_USER"],
  deleteUser: ["DELETE_USER"],
  updateUserCompanySettings: ["UPDATE_USER_COMPANY_SETTINGS"],
  // lender applications
  rejectApplication: ["REJECT_APPLICATION"],
  addInternalComment: ["ADD_INTERNAL_COMMENT"],
  reopenApplication: ["REOPEN_APPLICATION"],
  assignLenderUserLenderApplication: ["ASSIGN_LENDER_USER_LENDER_APPLICATION"],
  // lender responses
  saveBid: ["SAVE_BID"],
  deleteBid: ["DELETE_BID"],
  changeOnboardingStatus: ["CHANGE_ONBOARDING_STATUS"],
  markAsPaidOut: ["MARK_AS_PAID_OUT"],
} as const;
